import api from '../../shared/api/client';
import API_ROUTES from '../../shared/api/routes';

export const operationBlocksApi = {
  getAppConfig: (surface = 'WEB_ADMIN') =>
    api.get(API_ROUTES.operationBlocks.appConfig, {
      params: { surface, platform: 'WEB' },
    }),
  listOperationBlocks: (filters = {}) => api.get(API_ROUTES.operationBlocks.base, { params: filters }),
  getActiveOperationBlock: () => api.get(API_ROUTES.operationBlocks.active),
  createOperationBlock: (data) => api.post(API_ROUTES.operationBlocks.base, data),
  updateOperationBlock: (id, data) => api.put(API_ROUTES.operationBlocks.detail(id), data),
  scheduleOperationBlock: (id) => api.post(API_ROUTES.operationBlocks.schedule(id)),
  activateOperationBlock: (id) => api.post(API_ROUTES.operationBlocks.activate(id)),
  endOperationBlock: (id) => api.post(API_ROUTES.operationBlocks.end(id)),
  cancelOperationBlock: (id) => api.post(API_ROUTES.operationBlocks.cancel(id)),
};

export const {
  getAppConfig,
  listOperationBlocks,
  getActiveOperationBlock,
  createOperationBlock,
  updateOperationBlock,
  scheduleOperationBlock,
  activateOperationBlock,
  endOperationBlock,
  cancelOperationBlock,
} = operationBlocksApi;
